import { Icon } from '../';

export const ImageButton = ({
  imageSrc,
  isSelected,
  onClick = () => {},
}: {
  imageSrc?: string;
  isSelected?: boolean;
  onClick?(): void;
}) => (
  <div
    className={`
      relative
      flex
      items-center
      justify-center
      w-11
      h-11
      cursor-pointer
    `}
    onClick={onClick}
  >
    <div
      className={`
        absolute
        w-full
        h-full
        bg-black
        rounded-full
        ${isSelected && 'border border-primary'}
        overflow-hidden
      `}
    />
    <img
      className="absolute w-10 h-10 rounded-full hover:opacity-70"
      src={imageSrc}
      alt="icon"
    />
    {isSelected && (
      <div
        className={`
          absolute
          flex
          items-center
          justify-center
          -top-1
          -right-1
          w-4
          h-4
          rounded-full
          bg-primary
        `}
      >
        <Icon svgName="check" className="h-2.5 w-2.5" />
      </div>
    )}
  </div>
);
